import React, { useState } from "react";
import Reveal from "./Reveal";

const serviceOptions = [
  "📄 Thesis Writing",
  "📊 Data Analysis",
  "📚 Literature Review",
  "🗞️ Publication",
  "✏️ Editing",
  "🧪 Research Proposal",
  "🔍 Plagiarism Check",
  "🎓 Mentorship",
  "💎 Full Package",
];

export default function Contact() {
  const [form, setForm] = useState({ name: "", phone: "", email: "" });
  const [selected, setSelected] = useState([]);
  const [submitted, setSubmitted] = useState(false);

  const toggleService = (label) => {
    setSelected((prev) =>
      prev.includes(label) ? prev.filter((s) => s !== label) : [...prev, label]
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Hook this up to your backend / form service (e.g. Formspree, EmailJS, your own API).
    setSubmitted(true);
  };

  return (
    <section className="section-alt" id="contact">
      <div className="wrap">
        <Reveal className="section-head">
          <div className="eyebrow">Get In Touch</div>
          <h2>Book your free consultation</h2>
          <p>Tell us your needs and we'll get back to you within 24 hours with a custom research plan.</p>
        </Reveal>

        <div className="contact-grid">
          <Reveal as="div" className="contact-info">
            <h3>📬 Why reach out to us?</h3>
            <p style={{ color: "var(--ink-soft)" }}>
              Our research specialists review your requirements and propose a
              plan aligned with your academic goals and deadline.
            </p>
            <ul className="contact-list">
              <li>✅ Free initial consultation</li>
              <li>✅ Response within 24 hours</li>
              <li>✅ Tailored research roadmap</li>
              <li>✅ Dedicated PhD expert assigned</li>
              <li>✅ 30% off — limited time</li>
            </ul>
            <div className="contact-detail">
              <div>
                📧 <a href="mailto:support@infinityresearchwork.com">support@infinityresearchwork.com</a>
              </div>
              <div>
                📞 <a href="tel:+919058585894">+91-9058585894</a>
              </div>
              <div>📍 Sadar Bazar, Agra — 282001</div>
            </div>
          </Reveal>

          <Reveal as="div">
            {submitted ? (
              <div className="inquiry" style={{ textAlign: "center" }}>
                <h3>✅ We've got your request!</h3>
                <p style={{ color: "var(--ink-soft)", marginBottom: 0 }}>
                  Our team will contact you within 24 hours.
                </p>
              </div>
            ) : (
              <form className="inquiry" onSubmit={handleSubmit}>
                <div className="field">
                  <label htmlFor="fname">Full Name *</label>
                  <input
                    id="fname"
                    type="text"
                    placeholder="Your full name"
                    required
                    value={form.name}
                    onChange={(e) => setForm({ ...form, name: e.target.value })}
                  />
                </div>
                <div className="field">
                  <label htmlFor="fphone">Phone Number *</label>
                  <input
                    id="fphone"
                    type="tel"
                    placeholder="+91 XXXXX XXXXX"
                    required
                    value={form.phone}
                    onChange={(e) => setForm({ ...form, phone: e.target.value })}
                  />
                </div>
                <div className="field">
                  <label htmlFor="femail">Email Address *</label>
                  <input
                    id="femail"
                    type="email"
                    placeholder="you@example.com"
                    required
                    value={form.email}
                    onChange={(e) => setForm({ ...form, email: e.target.value })}
                  />
                </div>
                <div className="field">
                  <label>Select Services *</label>
                  <div className="chip-grid">
                    {serviceOptions.map((label) => (
                      <label className="chip" key={label}>
                        <input
                          type="checkbox"
                          checked={selected.includes(label)}
                          onChange={() => toggleService(label)}
                        />
                        {label}
                      </label>
                    ))}
                  </div>
                </div>
                <button type="submit" className="btn btn-gold" style={{ width: "100%" }}>
                  Submit Inquiry →
                </button>
                <p className="form-note">
                  🔒 Your information is 100% secure and never shared with third parties.
                </p>
              </form>
            )}
          </Reveal>
        </div>
      </div>
    </section>
  );
}
